/**
 * Substitutes the replacement object data into the given string.
 *
 * e.g. substitute('some random %(name)s here', {name: 'Tester'})
 * => 'some random Tester here'
 * @param str
 * @param replacements
 * @returns {any}
 */
export function substitute(str, replacements) {
    return str.replace(/%\(\w+?\)s/g, function(all) {
        let strippedKey = all.substring(2, all.length - 2);
        return strippedKey in replacements ? replacements[strippedKey] : strippedKey;
    });
}
